import { Auth0ProviderConfig } from './types';

const AUTH0_DOMAIN = 'konfidens.eu.auth0.com';
const AUTH0_MY_ACCOUNT_AUDIENCE = 'https://konfidens.eu.auth0.com/me/';
// Org-less SPA client for account linking. Auth0 Connected Accounts
// connections can't be enabled at the org level yet, so we use this
// client until Auth0 adds support. Same tenant as the Confidence app.
const ACCOUNT_LINKING_CLIENT_ID = 'dFIxN9g458zqxzKGinfSrbwfhzSJ7UU1';

export const GOOGLE_PROVIDER_CONFIG: Auth0ProviderConfig = {
  domain: AUTH0_DOMAIN,
  clientId: ACCOUNT_LINKING_CLIENT_ID,
  myAccountAudience: AUTH0_MY_ACCOUNT_AUDIENCE,
  connection: 'vedder-google',
  scopes:
    'profile email https://www.googleapis.com/auth/bigquery https://www.googleapis.com/auth/drive.readonly',
  connectedStorageKey: 'google-connected',
};

export const NOTION_PROVIDER_CONFIG: Auth0ProviderConfig = {
  domain: AUTH0_DOMAIN,
  clientId: ACCOUNT_LINKING_CLIENT_ID,
  myAccountAudience: AUTH0_MY_ACCOUNT_AUDIENCE,
  connection: 'notion',
  scopes: 'offline_access',
  connectedStorageKey: 'notion-connected',
};

export const LINEAR_PROVIDER_CONFIG: Auth0ProviderConfig = {
  domain: AUTH0_DOMAIN,
  clientId: ACCOUNT_LINKING_CLIENT_ID,
  myAccountAudience: AUTH0_MY_ACCOUNT_AUDIENCE,
  connection: 'linear',
  scopes: 'read,write',
  connectedStorageKey: 'linear-connected',
};

export const SENTRY_PROVIDER_CONFIG: Auth0ProviderConfig = {
  domain: AUTH0_DOMAIN,
  clientId: ACCOUNT_LINKING_CLIENT_ID,
  myAccountAudience: AUTH0_MY_ACCOUNT_AUDIENCE,
  connection: 'sentry',
  scopes: 'org:read project:read event:read',
  connectedStorageKey: 'sentry-connected',
};
